import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ETIQUETA_ESTADO, EstadoAsociacion, estadoDe } from '../../../services/asociacion-estado.service';

/**
 * Etiqueta de solo lectura con el estado de una asociación (Activa / Desactivada / Sin definir). SIN acciones: el estado se
 * cambia desde «Editar asociación» (sección «Estado y acceso») o desde «Administración de asociaciones».
 */
@Component({
  selector: 'app-estado-asociacion',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './estado-asociacion.component.html',
  // Apilamiento propio: la ficha tiene un panel blanco absoluto que tapa cualquier contenido sin z-index (incidente 2026-10-18).
  styles: [':host { display: block; position: relative; z-index: 2; }']
})
export class EstadoAsociacionComponent {
  @Input({ required: true }) asociacion!: { id?: number | null; nombre?: string | null; active?: number | boolean | null };

  get estado(): EstadoAsociacion { return estadoDe(this.asociacion?.active); }
  get etiqueta(): string { return ETIQUETA_ESTADO[this.estado]; }
}
